import { PrinterType } from 'viewmodels';

export const isGlobalPrinter = (printerType: string) => {
  if (printerType !== PrinterType.Teams && printerType !== PrinterType.Slack) {
    return false;
  }

  return true;
};
